import { observer } from 'mobx-react';
import * as React from 'react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Segment } from '../../../stores/SegmentStore';
import PartnerInternetDescriptionButton from '../partner/PartnerInternetDescriptionButton';
import { Notice } from 'telia-front-react';
import { InternetTech } from '../InternetCalculatorInterfaces';

interface Props {
  segment?: Segment;
  partner?: boolean;
  notices?: React.ReactNode;
  internetTechsOffered?: Set<InternetTech>;
}

@observer
class InternetCalculatorNotices extends React.Component<Props> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const { segment, partner, notices, internetTechsOffered } = this.props;

    if (segment === 'BUSINESS') {
      return notices ?? null;
    }

    const getAdditionalChargesKey = (baseKey: string) => {
      if (!internetTechsOffered?.size) {
        return baseKey;
      }
      if (internetTechsOffered.size === 2 && !internetTechsOffered.has('4G')) {
        return `${baseKey}.Without4gRouterPrice`;
      }
      if (internetTechsOffered.size === 1 && internetTechsOffered.has('CABLE')) {
        return `${baseKey}.WithOnlyCableRouterPrice`;
      }
      if (internetTechsOffered.size === 1 && internetTechsOffered.has('5G')) {
        return `${baseKey}.WithOnly5gRouterPrice`;
      }
      if (!internetTechsOffered.has('CABLE')) {
        return `${baseKey}.WithoutCableRouterPrice`;
      }
      return baseKey;
    };

    return (
      <div className="text-left">
        {notices}
        <Notice size="small">{translate(getAdditionalChargesKey('internetAndTvCalculator.additionalCharges'))}</Notice>
        {partner && <PartnerInternetDescriptionButton segment={segment} />}
      </div>
    );
  }
}

export default InternetCalculatorNotices;
